import zhCn from './zh-cn'
import enUs from './en-us'
import idId from './id-id'
import jaJp from './ja-jp'
import kmKh from './km-kh'
import koKr from './ko-kr'
import loLa from './lo-la'
import msMy from './ms-my'
import myMm from './my-mm'
import thTh from './th-th'
import tlPh from './tl-ph'
import viVn from './vi-vn'
import zhTw from './zh-tw'

export default {
  'zh-cn': zhCn,
  'en-us': enUs,
  'id-id': idId,
  'ja-jp': jaJp,
  'km-kh': kmKh,
  'ko-kr': koKr,
  'lo-la': loLa,
  'ms-my': msMy,
  'my-mm': myMm,
  'th-th': thTh,
  'tl-ph': tlPh,
  'vi-vn': viVn,
  'zh-tw': zhTw,
}
